import { Link, Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import PageSkeleton from "../components/PageSkeleton";
import { useData } from "../context/DataContext";

export default function Dashboard() {
  const { data, loading, error, refresh, scenario } = useData();
  const loc = useLocation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="mx-auto max-w-[1480px] px-4 sm:px-6 lg:px-10 py-8">
        {loading && !data ? (
          <div data-testid="data-loading"><PageSkeleton /></div>
        ) : error ? (
          <div className="py-24 text-center" data-testid="data-error">
            <div className="eyebrow text-[#6B2F2A] mb-2">Could not load the dataset</div>
            <div className="font-mono-num text-sm text-[#6B2F2A]">{String(error)}</div>
            <button
              onClick={refresh}
              className="mt-6 px-4 py-2 border border-[var(--rule-strong)] text-xs font-display tracked-tight uppercase hover:bg-[var(--paper-soft)]"
              data-testid="data-error-retry"
            >
              Try again
            </button>
          </div>
        ) : data ? (
          <div key={`${loc.pathname}·${scenario}`} className="animate-page">
            <Outlet />
          </div>
        ) : null}
      </main>
      <footer className="mx-auto max-w-[1480px] px-4 sm:px-6 lg:px-10 py-10 border-t border-[var(--rule)] mt-12">
        <div className="flex justify-between items-center eyebrow text-[var(--soft-fg)]">
          <span>
            Monk Mackenzie · Forecasting
            <Link to="/admin/help" className="ml-3 hover:text-[var(--ink)] transition-colors" data-testid="footer-manual-link">
              Manual
            </Link>
          </span>
          <span className="font-mono-num">single source of truth · {data?.meta?.currency || "NZD"}</span>
        </div>
      </footer>
    </div>
  );
}
